import AtmsDataView from "./AtmsDataView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SearchAtm from "./SearchAtm";


const defaultFilterData: IAtmSearchForm = {
  description: "",
  //sapCode: "",
  unID: "",
  deleted: "",
  atmTerm: "",
  lineType: "",
  comments: ""
}

const Atms = () => {
  
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView  title="Αναζήτηση ATM">
        <SearchAtm />
      </SydFilterView>

      <AtmsDataView />
    </SydFilterProvider>
  )

}
export default Atms;

